"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["as", "children"];
var Button = function Button(_ref) {
  var Tag = _ref.as,
    children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(Tag, props, children);
};
Button.propTypes = {
  as: _propTypes.default.string,
  children: _propTypes.default.node.isRequired
};
Button.defaultProps = {
  as: 'button'
};
var _default = exports.default = Button;
